import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEmployeeState }       from 'Redux/Slices/Employee/EmployeeSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const deleteEmployeeRequest = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteEmployeeSuccess = (state: Draft<IEmployeeState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if (payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.entries = newEntries;
};

export const deleteEmployeeFailure = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
